var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRecordingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0.599609C15.1915 0.599609 19.4004 4.80852 19.4004 10C19.4004 15.1915 15.1915 19.4004 10 19.4004C4.80852 19.4004 0.599609 15.1915 0.599609 10C0.599609 4.80852 4.80852 0.599609 10 0.599609Z",
    fill: "#F0EFFB",
    stroke: "#965EFA",
    strokeWidth: 1.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5459 9.99999C4.5459 6.98752 6.98798 4.54544 10.0004 4.54544C13.0129 4.54544 15.455 6.98752 15.455 9.99999C15.455 13.0124 13.0129 15.4545 10.0004 15.4545C6.98798 15.4545 4.5459 13.0124 4.5459 9.99999Z",
    fill: "#FF2828"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecordingIcon);
export default __webpack_public_path__ + "static/media/recording-icon.eeadc325a6799c725622bec55b08621e.svg";
export { ForwardRef as ReactComponent };